// src/config/hiddenLeagues.js
//
// Ligas ocultas del dashboard (frontend SOLAMENTE — el bot las sigue
// procesando y subiendo a RTDB; acá solo se excluyen del render).
//
// Historia: se creó para ocultar MPBL (2026-06-11, nunca tiene línea de
// BetsAPI), pero Mati revirtió la decisión el mismo día — el estado
// "BLOQUEADO · Esperando datos" comunica bien. La lista queda vacía,
// la infraestructura lista por si algún día se quiere ocultar una liga.
//
// Para ocultar una liga: agregar el nombre tal como llega de RTDB
// (campo `liga`) a HIDDEN_LEAGUES. El matching usa normalizeLeague()
// (case-insensitive, sin diacríticos, tolerante a guiones/espacios).

import { normalizeLeague } from '../utils';

export const HIDDEN_LEAGUES = [];

const HIDDEN_SET = new Set(HIDDEN_LEAGUES.map(normalizeLeague));

/** true si la liga del partido está en la lista de ocultas. */
export function isHiddenLeague(liga) {
  const norm = normalizeLeague(liga);
  return norm !== '' && HIDDEN_SET.has(norm);
}
